import React from 'react';
import { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';



export default function LoginBnSmall() {
    const { isAuthenticated, login, logout, userEmail, loading } = useAuth();
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
        setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLoginSuccess = async (response) => {    
        try {
            const backendResponse = await axios.post(
                `${API_URL}/google-login`,
                { token: response.credential }
            );
            if (backendResponse.data.status === "success") {
                login(backendResponse.data.token, backendResponse.data.email, backendResponse.data.given_name, backendResponse.data.family_name);
                navigate('/');
            } else {
                console.error("Login failed:", backendResponse.data.message);
            }
        } catch (err) {
            console.error("Error in backend authentication:", err);
        }
    };

    
    return (
        <GoogleOAuthProvider clientId="867114610891-nr7ubmj0roh0dn3p684s7tgj7qniuc9h.apps.googleusercontent.com">
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {loading ? (
            <span style={{ fontSize: '0.9rem' }}>Loading...</span>
            ) : !isAuthenticated ? (
            <GoogleLogin
                onSuccess={handleLoginSuccess}
                onError={() => console.log('Login Failed')}
                style={{
                    width: isMobile ? '150px' : '200px', // Small on mobile, large on desktop
                    height: isMobile ? '40px' : '50px',
                    fontSize: isMobile ? '14px' : '16px',
                }}
            />
            ) : (
            <>
                <span style={{ fontSize: '0.9rem', whiteSpace: 'nowrap' }}>
                Welcome, {userEmail}!
                </span>
                <button
                className="btn btn-sm btn-outline-danger"
                onClick={logout}
                style={{ fontSize: '0.8rem', padding: '2px 8px' }}
                >
                Logout
                </button>
            </>
            )}
        </div>
        </GoogleOAuthProvider>
    );
};
